Vue.filter('currencyPYG', function (value) {
  if (!value) return ''
  value = parseFloat(value) / 100
  return new Intl.NumberFormat('ES-AR', { style: 'currency', currency: 'PYG' }).format( value ) 
})

var app = new Vue({
  el: '#shipping-estimator-creative',
  delimiters: ["<%","%>"],
  data: {
    departament: '',
    city: '',
    neighborhood: '',
    departament_options: [],
    city_options: [],
    neighborhood_options: [],
    city_selected: 'Seleccione una ciudad',
    neighborhood_selected: 'Seleccione un barrio',
    rates : [],
    canSubmit: false,
    estimation: 'Estimación'
  },
  methods: {
    getCity: function( e ){
      this.city_selected = 'Cargando ciudades';
      this.city = '';
      this.neighborhood = '';
      this.neighborhood_options = [];
      fetch( `https://innovateshopifyapps.com/inverfin-test/carrier-service/city?departament_code=${escape(this.departament)}`)
      .then( res =>  res.json() )
      .then( json => { 
        this.city_options  = { ... json }
        this.city_selected = 'Seleccione su ciudad';
      });
    },
    getNeighborhood: function(){
      this.neighborhood = '';
      this.neighborhood_options = [];
      this.neighborhood_selected = 'Cargando Barrios...';
      fetch( `https://innovateshopifyapps.com/inverfin-test/carrier-service/neighborhood?code_city=${escape(this.city)}`)
      .then( res =>  res.json() )
      .then( json => { 
        this.neighborhood_options  = { ... json }
        this.neighborhood_selected = 'Seleccione su Barrio';
        this.canSubmit = true;
        //this.neighborhood = this.neighborhood_options[0]['a:codigoBarrio']
        //document.getElementById('company').focus()
      });

    },
    loadSelect: function( id , value ){
      var select = document.getElementById(`${id}`);

      var process = setInterval(function(){
        if( select.options.length > 1 ){
          var selected = [...select.options].filter( option => option.innerText.trim() == value )
          select.value = selected[0].value;

          var event = new Event('change');
          select.dispatchEvent(event);
          var event = new Event('blur');
          select.dispatchEvent(event);
          clearInterval(process);

        }
      }, 1000);
	},
    getValue: function( id ){
      return document.getElementById(''+ id +'').options[document.getElementById(''+ id +'').options.selectedIndex].innerText.trim()
    },
	getShippingCost: async function( e ){
        e.preventDefault();
    	this.estimation = 'Cargando...';
            const data = {
                "rate": {
                "destination": {
                "address1": this.getValue('address-new[departament]'),
                "address2": this.getValue('address-new[departament]'),
                "city": this.getValue('address-new[city]'),
                "company_name": this.getValue('address-new[company]'),
              },
              "items": [{
                "quantity": 1,
                "grams": 6333,
                "price": 20919,
              }],
            }
        };

		const request = await fetch( 'https://innovateshopifyapps.com/inverfin-test/carrier-service/rates' , {
                	      	method: 'POST',
                    	  	body: JSON.stringify( data ),
            				headers: { 'Content-Type': 'application/json'}
				        })
    	const response = await request.json();

    	this.rates = response.rates;
		this.estimation = 'Estimación';
    },
  },
  mounted: async function(){

  	const data = await fetch( 'https://innovateshopifyapps.com/inverfin-test/carrier-service/departament')
  	const result = await data.json();
  	this.departament_options  = {...result}

   }
})